import sileo from 'sileo';


/*
 * ToDo related models
 **/
const Todo = new sileo.Model('hqzen', 'todo');
const NavbarLauncherTodo = new sileo.Model('hqzen', 'navbar-launcher-todos');

const state = {
    hasToDos: {},
    isFetchingNavbarTodos: false,
    navbarLauncherEmploymentToDos: {}
};


const getters = {
    getTodos: state => state.hasToDos,
    getIsFetchingNavbarTodos: state => state.isFetchingNavbarTodos,
    getNavbarLauncherEmploymentToDos: state => state.navbarLauncherEmploymentToDos,
};


const mutations = {
    setTodos(state, todos) {
        state.hasToDos = todos;
    },
    setIsFetchingNavbarTodos(state, isFetching) {
        state.isFetchingNavbarTodos = isFetching;
    },
    setNavbarLauncherEmploymentToDos(state, todos) {
        state.navbarLauncherEmploymentToDos = todos;
    },
};

const actions = {
    /**
     * Asynchronously fetches To-Do items based on specified
     * filters (Company Id and Workforce Id) and updates the Vuex store.
     * After fetching the data, it commits the response to the Vuex store using the 'setTodos' mutation.
     *
     * @param {Object} context - The Vuex context object, providing access to store properties like commit.
     * @param {Object} filters - An object containing filters to apply when fetching To-Do items.
     *
     * @returns {Promise<Object>} - A promise that resolves to an object representing the status of pending To-Do items.
     *   The structure of the returned object is as follows (By default would always be false if none):
     *   {
     *      has_employment_todos: {boolean},
     *      has_forms_todos: {boolean},
     *      has_manager_todos: {boolean},
     *      has_milestone_todos: {boolean},
     *      has_recruitment_todos: {boolean},
     *      has_supervisor_todos: {boolean},
     *   }
     *   Each boolean value indicates whether there are pending To-Do items in a specific Todo category.
    */

    async fetchToDos(context, filters) {
        let response = await Todo.objects.filter(filters);
        context.commit('setTodos', response);
        return response;
    },

    async fetchNavbarLauncherTodos({ state, commit }, filters) {
        if (state.isFetchingNavbarTodos) return;
        commit('setIsFetchingNavbarTodos', true);
        try {
            const response = await NavbarLauncherTodo.objects.filter(filters);
            const { employment_todos: navbarLauncherEmploymentToDos } = response;
            commit('setNavbarLauncherEmploymentToDos', navbarLauncherEmploymentToDos);
            return response;
        } catch (error) {
            console.error('Error fetching navbar launcher todos:', error);
        } finally {
            commit('setIsFetchingNavbarTodos', false);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
